import { captureException } from '@sentry/nextjs';

export const onError = (error: any) => captureException(error);
